<template>
  <div id="equipment" @click="emitClick">
    <div
      v-if="!is_preview || (is_preview && equipment.primary_color != '')"
      class="uniform"
    >
      <Shirt
        :primary_color="equipment.primary_color"
        :type="equipment.type"
        :secondary_color="equipment.secondary_color"
        :view_box="shirt_viewBox"
        :shirt_height="shirt_height"
        :sport="sport"
      ></Shirt>
      <Shorts
        :color="equipment.pants_color"
        :view_box="shorts_viewBox"
        :shorts_height="shorts_height"
        :sport="sport"
      ></Shorts>
      <Socks
        v-if="sport == 'football'"
        :color="equipment.socks_color"
        :view_box="socks_viewBox"
        :socks_height="socks_height"
        :sport="sport"
      ></Socks>
    </div>

    <div class="selects">
      <div v-if="!is_preview">
        <label
          >{{ $t("params.type") }} <span class="obligatory">*</span>
        </label>
        <select
          v-bind:class="error.type ? 'error' : ''"
          v-model="equipment.type"
        >
          <option v-for="type in types" v-bind:value="type" v-bind:key="type">
            {{ $t("equipment_type." + type) }}
          </option>
        </select>
      </div>
      <div v-if="!is_preview">
        <label
          >{{ $t("params.primary_color") }} <span class="obligatory">*</span>
        </label>
        <select
          v-bind:class="error.primary_color ? 'error' : ''"
          v-model="equipment.primary_color"
        >
          <option
            v-for="color in colors"
            v-bind:value="color"
            v-bind:key="color"
          >
            {{ $t("colors." + color) }}
          </option>
        </select>
        <!-- <span class="test" v-for="color in colors" :style="{backgroundColor:color}"></span> -->
      </div>
      <div v-if="equipment.type != 'one_colour' && !is_preview">
        <label
          >{{ $t("params.secondary_color") }} <span class="obligatory">*</span>
        </label>
        <select
          v-bind:class="error.secondary_color ? 'error' : ''"
          v-model="equipment.secondary_color"
        >
          <option
            v-for="color in colors"
            v-bind:value="color"
            v-bind:key="color"
          >
            {{ $t("colors." + color) }}
          </option>
        </select>
      </div>
      <div v-if="!is_preview">
        <label
          >{{ $t("params.pants_color") }} <span class="obligatory">*</span>
        </label>
        <select
          v-bind:class="error.pants_color ? 'error' : ''"
          v-model="equipment.pants_color"
        >
          <option
            v-for="color in colors"
            v-bind:value="color"
            v-bind:key="color"
          >
            {{ $t("colors." + color) }}
          </option>
        </select>
      </div>
      <div v-if="!is_preview && sport == 'football'">
        <label
          >{{ $t("params.socks_color") }} <span class="obligatory">*</span>
        </label>
        <select
          v-bind:class="error.socks_color ? 'error' : ''"
          v-model="equipment.socks_color"
        >
          <option
            v-for="color in colors"
            v-bind:value="color"
            v-bind:key="color"
          >
            {{ $t("colors." + color) }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>
<script>
import i18n from "@/i18n";
import Shirt from "@/components/equipment/Shirt.vue";
import Shorts from "@/components/equipment/Shorts.vue";
import Socks from "@/components/equipment/Socks.vue";

export default {
  name: "Equipment",
  components: {
    i18n,
    Shirt,
    Shorts,
    Socks
  },
  props: {
    equipment: {
      default: function() {
        return {
          primary_color: "",
          secondary_color: "",
          type: "",
          pants_color: "",
          socks_color: ""
        };
      }
    },
    error: "",
    number: "",
    is_preview: "",
    shirt_viewBox: "",
    shorts_viewBox: "",
    socks_viewBox: "",
    svg_height: "",
    svg_width: "",
    shirt_height: "",
    shorts_height: "",
    socks_height: "",
    sport: ""
  },
  /*
      props: [
          'equipment',
          'error',
          'number',
          'is_preview',
          'shirt_viewBox',
          'shorts_viewBox',
          'socks_viewBox',
          'svg_height',
          'svg_width',
          'shirt_height',
          'shorts_height',
          'socks_height'
      ],
      */
  data() {
    return {
      colors: [
        "yellow",
        "blue",
        "LightBlue",
        "white",
        "maroon",
        "grey",
        "violet",
        "brown",
        "orange",
        "black",
        "red",
        "pink",
        "green",
        "mediumpurple",
        "darkblue",
        "#134957",
        "#207085",
        "#efb810",
        "#AAEF79",
        "salmon"
      ],
      types: [
        "one_colour",
        "horizontal_stripes",
        "vertical_stripes",
        "diagonal_strip",
        "inverted_chevron",
        "arlequine"
      ]
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    emitClick() {
      this.$emit("click");
    }
  }
};
</script>
<style lang="scss" scoped>
#equipment {
  display: block;
  width: 100%;

  .test {
    display: inline-block;
    width: 30px;
    height: 30px;
    margin: 5px;
  }

  div {
    width: 100%;
  }

  input,
  select {
    width: 100%;
    padding: 0;
    margin-bottom: 0;
    border: 1px solid $secondary-color;
    outline: none;
    font-size: 11pt;
    border-radius: 3px;
    padding: 10px;
    margin: 5px 0;
  }

  select option {
    font-size: 14pt;
  }

  select {
    background-image: url("/img/sort-down.svg");
    background-size: 10px;
    background-position: right 10px center;
    background-repeat: no-repeat;
  }

  label {
    font-size: 14px;
    padding: 0;
    margin-bottom: 5px;
    display: block;
  }

  .obligatory {
    color: $alert-color;
    font-weight: bold;
    font-size: 20px;
  }

  .error {
    border-color: $alert-color;
    &::placeholder {
      color: $alert-color;
      opacity: 0.5;
    }
  }
}
</style>
